import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

type ProviderStats = {
  finished?: number;
  canceled?: number;
  inprogress?: number;
};

@Component({
  selector: "app-provider-stats-cards",
  templateUrl: "./provider-stats-cards.component.html",
  styleUrls: ["./provider-stats-cards.component.scss"],
  standalone: false,
})
export class ProviderStatsCardsComponent {
  @Input() stats: ProviderStats | null = null;

  constructor(private router: Router) {}

  goTo(page: "passed" | "canceled" | "suivi"): void {
    this.router.navigate(["/prestataire/track-demands"], {
      queryParams: { page },
    });
  }
}
